export default __webpack_public_path__ + "static/mandala-8bb8e440475c30b35b2fa75ad447a477.png";